// extracted by css-extract-rspack-plugin
var _1 = "kf";
var _2 = "j9";
var _3 = "j8";
var _4 = "h";
var _5 = "j5";
var _6 = "e1";
var _7 = "j7";
var _8 = "eh";
var _9 = "fu";
var _a = "kk";
var _b = "hb";
var _c = "ka";
var _d = "j4";
var _e = "kj";
var _f = "kc";
var _10 = "f2";
var _11 = "kb";
var _12 = "ke";
var _13 = "j6";
var _14 = "kg";
var _15 = "ki";
var _16 = "j2";
var _17 = "j3";
var _18 = "jy";
var _19 = "as";
var _1a = "kh";
var _1b = "e0";
var _1c = "j0";
var _1d = "jz";
var _1e = "j1";
var _1f = "f";
export { _1 as "appsStoreImage", _2 as "bottom", _3 as "coffee", _4 as "content", _5 as "cupLabel", _6 as "description", _7 as "desert", _8 as "discounts", _9 as "footer", _a as "footerImage", _b as "header", _c as "infoContainer", _d as "labelsContainer", _e as "last", _f as "linkActions", _10 as "linkComponent", _11 as "linkContainer", _12 as "linkDescription", _13 as "milkShake", _14 as "mobileIcon", _15 as "prizeBox", _16 as "productsGroup", _17 as "productsImage", _18 as "stampLoyaltyCardComponent", _19 as "standardContainer", _1a as "textTile", _1b as "title", _1c as "titleContainer", _1d as "top", _1e as "withButtons", _1f as "wrapper" }
